import { render } from "./OrganisationMembers.vue?vue&type=template&id=611e4ea2"
import script from "./OrganisationMembers.vue?vue&type=script&lang=js"
export * from "./OrganisationMembers.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__